// extracted by mini-css-extract-plugin
export var bubble = "_1t-0";
export var container = "_1t-f";
export var contrastBorder = "_1t-g";
export var greyOut = "_1t-2";
export var initialsColor0 = "_1t-3";
export var initialsColor1 = "_1t-4";
export var initialsColor10 = "_1t-d";
export var initialsColor11 = "_1t-e";
export var initialsColor2 = "_1t-5";
export var initialsColor3 = "_1t-6";
export var initialsColor4 = "_1t-7";
export var initialsColor5 = "_1t-8";
export var initialsColor6 = "_1t-9";
export var initialsColor7 = "_1t-a";
export var initialsColor8 = "_1t-b";
export var initialsColor9 = "_1t-c";
export var initialsWrapper = "_1t-1";
export var large = "_1t-l";
export var medium = "_1t-k";
export var mediumSmall = "_1t-j";
export var mediumSmallMedium = "_1t-o";
export var micro = "_1t-h";
export var small = "_1t-i";
export var tiny = "_1t-n";
export var xTiny = "_1t-m";